import {useEffect, useState, useRef} from 'react';

interface IntersectionObserverInit {
    root?: Element | null;
    rootMargin?: string;
    threshold?: number;
}

function useInView(options: IntersectionObserverInit = {}): [any, boolean] {
    const [inView, setInView] = useState(false);
    const ref = useRef<HTMLElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setInView(entry.isIntersecting);
            },
            {
                root: options?.root || null,
                rootMargin: options?.rootMargin || '0px',
                threshold: options?.threshold || 0
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [options]);

    return [ref, inView];
}

export default useInView;
